import { Box, Card, Container, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SchedulePage } from "./pages/SchedulePage";
import { ScheduleToolbar } from "./pages/ScheduleToolbar";

export function ScheduleUICard() {
  const theme = useTheme();
  const fullscreenCalendar = useMediaQuery(theme.breakpoints.up("md"));
  const moveCalendarEventToAppointment = useMediaQuery(
    theme.breakpoints.up("lg")
  );

  return (
    <Box
      component="main"
      className="schedule-container"
      sx={{
        flexGrow: 1,
        py: 6,
      }}
    >
      <Container maxWidth={false}>
        <ScheduleToolbar />
        <Box sx={{ mt: 3 }}>
          <Card sx={{ p: 5, mt: 2 }}>
            <Box sx={{ mt: 1 }}>
              <SchedulePage
                fullscreen={fullscreenCalendar}
                appointment={moveCalendarEventToAppointment}
              />
            </Box>
          </Card>
        </Box>
      </Container>
    </Box>
  );
}
